export default function loadCalculation(
  defaultValues,
  externalCalc,
  externalExampleCalc,
  questions,
  setQuestions,
  setAnswers,
  setCurrentValues,
  setShowUpdateFields,
  setNumberOfProperties
) {
  let updatedAnswers = [];

  setQuestions(questions);

  // extract current DSCR interest rates from capital page's data
  // const DSCRRateRange = extractDSCRInterestRateRange(CapitalData);
  // setDSCRRateRange(DSCRRateRange);

  // if loaded on /my/calculations
  // where we preload existing/saved calcs

  if (externalCalc && externalCalc.Answers.length > 0) {
    // external calcs, can be 'new' calcs, that don't have answers, so other part of the if is relevant
    updatedAnswers = externalCalc.Answers.slice(0);

    updatedAnswers.forEach((answer) => {
      const [questionWithSameId] = questions.filter(
        (question) => question.q_id === answer.q_id
      );

      if (questionWithSameId) {
        // Update the answer with the corresponding question's properties
        answer.q_description = questionWithSameId.q_description;
        answer.q_title = questionWithSameId.q_title;
        answer.node_type = questionWithSameId.node_type;
        answer.a_type = questionWithSameId.a_type;
        answer.a_input_type = questionWithSameId.a_input_type;
        answer.a_opts = questionWithSameId.a_opts;
        answer.q_next_step_func = questionWithSameId.q_next_step_func;
        answer.q_validation_func = questionWithSameId.q_validation_func;
        answer.q_invalid_answer_help_text =
          questionWithSameId.q_invalid_answer_help_text;
        answer.a_error = questionWithSameId.a_error;
      }
    });

    setAnswers(updatedAnswers);

    setShowUpdateFields(true);
  } else {
    let q_id_counter = "";
    let answers = [];
    const questionsSlice = questions.slice(); // make sure to make a copy
    let leftMostPath = questionsSlice.filter((question) => {
      // https://stackoverflow.com/a/21596128/1933331
      return /^0*$/.test(question.q_id);
    });

    // leftMostPath
    // must sort based on q_id length of 0s inside
    // left most paths q_ids
    leftMostPath.sort((a, b) => a.q_id.length - b.q_id.length);

    // leftMostPath for initial state
    // as user selects answers,
    // the path deviates and questions ahead change
    // this populates empty placeholder answers from initial questions
    for (let i = 0; i < leftMostPath.length; i++) {
      const question = leftMostPath[i];

      // create some defaults and pre-sets
      // to reduce users number of click
      let preset_a = "";

      if (
        externalExampleCalc &&
        Object.keys(externalExampleCalc).length > 0 &&
        Object.keys(externalExampleCalc).includes(question.q_title)
      ) {
        preset_a = externalExampleCalc[question.q_title];
      }

      q_id_counter = q_id_counter + "0";
      answers.push({
        a_string: preset_a,
        q_id: new Array(i + 2).join("0"),
        q_description: question.q_description,
        q_title: question.q_title,
        node_type: question.node_type,
        a_type: question.a_type,
        a_input_type: question.a_input_type,
        a_opts: question.a_opts,
        q_next_step_func: question.q_next_step_func,
        q_validation_func: question.q_validation_func,
        q_invalid_answer_help_text: question.q_invalid_answer_help_text,
        a_error: question.a_error,
      });
    }

    updatedAnswers = answers;
  }

  setAnswers(updatedAnswers);
  // set number of properties for potfolio if necessary

  // Extract property count from answers; default to 0 if not present
  const propertyCountAnswer = updatedAnswers.find(
    (a) => a.q_title === "Number of properties"
  )?.a_string;

  const normalizedPropertyCount = parseInt(propertyCountAnswer || 0) || 0;
  if (setNumberOfProperties) {
    setNumberOfProperties(normalizedPropertyCount);
  }
}
